import React from "react";
import { Routes, Route, useParams, Navigate } from "react-router-dom";
import { getDocByRoute, getDefaultDoc } from "../config/docs-config";
import DocsLayout from "../components/docs-layout";
import DocsContent from "../components/docs-content";

/**
 * Component that renders a specific doc page based on route params.
 */
function DocPageContent() {
  const { sectionId, slug } = useParams<{
    sectionId: string;
    slug: string;
  }>();

  if (!sectionId || !slug) {
    const defaultDoc = getDefaultDoc();
    return (
      <Navigate
        to={`/docs/${defaultDoc.sectionId}/${defaultDoc.slug}`}
        replace
      />
    );
  }

  const docConfig = getDocByRoute(sectionId, slug);

  if (!docConfig) {
    const defaultDoc = getDefaultDoc();
    return (
      <Navigate
        to={`/docs/${defaultDoc.sectionId}/${defaultDoc.slug}`}
        replace
      />
    );
  }

  return (
    <DocsLayout>
      <DocsContent
        markdownUrl={docConfig.markdownUrl}
        title={docConfig.title}
      />
    </DocsLayout>
  );
}

/**
 * Main documentation page component.
 * Handles routing to specific documentation pages based on URL parameters.
 */
function DocsPage() {
  return (
    <Routes>
      <Route path=":sectionId/:slug" element={<DocPageContent />} />
      <Route
        path="*"
        element={
          <Navigate
            to={`/docs/${getDefaultDoc().sectionId}/${getDefaultDoc().slug}`}
            replace
          />
        }
      />
    </Routes>
  );
}

export default React.memo(DocsPage);
